import { jsx } from "react/jsx-runtime";
import { Delete } from "@wix/wix-ui-icons-common";
import { Spinner, IconButton } from "@wix/wix-ui-tpa/cssVars";
import { DATA_HOOKS } from "../dataHooks.js";
import { classes, st } from "../FileUpload.st.css";
const FileUploadIndicator = ({
  state,
  onDeleteClick,
  deleteButtonRef,
  "aria-label": ariaLabel
}) => {
  if (state === "uploading") {
    return /* @__PURE__ */ jsx(Spinner, { "data-hook": DATA_HOOKS.spinner, className: classes.spinner });
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: st(classes.delete, {
        error: state === "error"
      }),
      children: /* @__PURE__ */ jsx(
        IconButton,
        {
          innerRef: deleteButtonRef,
          "data-hook": DATA_HOOKS.delete,
          onClick: onDeleteClick,
          "aria-label": ariaLabel,
          icon: /* @__PURE__ */ jsx(Delete, { "aria-hidden": "true" })
        }
      )
    }
  );
};
export {
  FileUploadIndicator as default
};
//# sourceMappingURL=FileUploadIndicator.js.map
